import React, { useEffect, useState } from 'react';
import { Modal, Table, TablePaginationConfig } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import moment from 'moment';
import { fetchChangeOrdersData } from '../../store/reducers/orderDashboardSlice';

interface ChangeOrdersModalProps {
  visible: boolean;
  onCancel: () => void;
  selectedSOWData: any;
}

const ChangeOrdersModal: React.FC<ChangeOrdersModalProps> = ({ visible, onCancel, selectedSOWData, }) => {
  const dispatch = useDispatch();
  const [changeOrderData, setChangeOrderData] = useState<any>([]);
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  useEffect(() => {
    if (visible && selectedSOWData?.sowId) {        
        fetchChangeOrdersWithPagination();
    } else {
    setChangeOrderData([]);
      setTotalCount(0);
      setPageNo(0);
      setPageSize(10);
    }
  }, [visible, selectedSOWData, pageNo, pageSize]);

//   useEffect(() => {
//     if (userDashboard.auditloglist) {
//         setChangeOrderData(userDashboard.auditloglist);
//     }
//   }, [userDashboard.auditloglist]);

//   useEffect(() => {
    // setEmployeeName(selectedemployeeData.employeeName ? selectedemployeeData.employeeName : '');
    // setEmployeeEmail(selectedemployeeData.employeeEmail ? selectedemployeeData.employeeEmail : '');
//   }, [selectedemployeeData.employeeName, selectedemployeeData.employeeEmail]);

  const fetchChangeOrdersWithPagination = () => {
    dispatch(fetchChangeOrdersData({ sowId: selectedSOWData.sowId })).then(
      (response: any) => {        
        if (response.type !== 'orderDashboard/fetchChangeOrdersData/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else{
            // setTotalCount(response.payload.totalElements);
            setChangeOrderData(response.payload);
            // setChangeOrderData([...response.payload, ...response.payload, ...response.payload]);
            setPageNo(0);
        }
      }
    );
  };

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };

  const columns = [
    {
      title: 'Modified Date',
      dataIndex: 'localDateTime',
      key: 'localDateTime',
      width: 150,
      render: (text: string, record: any) => (
        <span>{record.localDateTime && moment(record.localDateTime.toString()).format('YYYY-MM-DD')}</span>
      ),
    },
    {
      title: 'Changed Field',
      dataIndex: 'columnName',
      key: 'columnName',
      width: 150,
    },
    {
      title: 'Old Value',
      dataIndex: 'oldvalue',
      key: 'oldValue',
      width: 150,
    },
    {
      title: 'New Value',
      dataIndex: 'newValue',
      key: 'newValue',
      width: 150,
    },
  ];

  return (
    <Modal
      title="Change Order History"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
          zIndex: 9998,
        },
      }}
    >
      <div>
        <div>
          <p>
            <b>SOW ID:</b> {selectedSOWData?.sowId}
          </p>
          {/* <p>
            <b>User Email:</b> {selectedemployeeData?.email}
          </p> */}
        </div>
        <Table
          dataSource={changeOrderData}
          columns={columns}
          scroll={{ x: 'max-content', y: 300}}
          className='table-style'
          loading={orderDashboardData?.loading}
          pagination={{
            // current: pageNo + 1,
            pageSize,
            // total: totalCount,
            showSizeChanger: false
          }}
          // onChange={handleTableChange}
        />
      </div>
    </Modal>
  );
};

export default ChangeOrdersModal;